import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { MenuPage } from './pages/MenuPage';
import { InventoryPage } from './pages/InventoryPage';
import { HrPage } from './pages/HrPage';
import { PayrollPage } from './pages/PayrollPage';
import { FinancePage } from './pages/FinancePage';
import { ReportsPage } from './pages/ReportsPage';
import { AdminPage } from './pages/AdminPage';
import { PosSettingsPage } from './pages/PosSettingsPage';
import { CrmPage } from './pages/CrmPage';
import { ReservationsPage } from './pages/ReservationsPage';
import { DeliveryPage } from './pages/DeliveryPage';
import { SettingsPage } from './pages/SettingsPage';
import { DashboardLayout } from './components/DashboardLayout';

function getToken(): string | null {
  try {
    return JSON.parse(localStorage.getItem('urs-auth') ?? '{}')?.state?.token ?? null;
  } catch {
    return null;
  }
}

function RequireAuth() {
  return getToken() ? <Outlet /> : <Navigate to="/login" replace />;
}

function RedirectIfAuthed() {
  return getToken() ? <Navigate to="/dashboard" replace /> : <LoginPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<RedirectIfAuthed />} />
        <Route element={<RequireAuth />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/hr" element={<HrPage />} />
            <Route path="/payroll" element={<PayrollPage />} />
            <Route path="/finance" element={<FinancePage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/pos-settings" element={<PosSettingsPage />} />
            <Route path="/crm" element={<CrmPage />} />
            <Route path="/reservations" element={<ReservationsPage />} />
            <Route path="/delivery" element={<DeliveryPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
